import React from "react"
import { FaFolder, FaShoppingBag } from "react-icons/fa"
export default [
  {
    id: 1,
    icon: <FaFolder className="service-icon" />,
    title: "Portfolio websites",
    text: `React, Gatsby, Strapi, JavaScript, HTML5, CSS3, Formspree, Contentful, Bootstrap, Netlify`,
  },
 
  {
    id: 2,
    icon: <FaShoppingBag className="service-icon" />,
    title: "E-Commerce websites",
    text: `Gatsby, React, JavaScript, HTML5, CSS3, Formspree, Snipcart, Contentful, Bootstrap, Netlify`,
  },
]
